import { render, staticRenderFns } from "./IconSvgPlus.vue?vue&type=template&id=a45eaff8&scoped=true&"
import script from "./IconSvgPlus.vue?vue&type=script&lang=js&"
export * from "./IconSvgPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45eaff8",
  null
  
)

export default component.exports